<template>
  <section class="file-container" :class="{ selected: selected }">
    <template>
      <select-box
        class="select-box"
        @action="$emit('select-file', file, 'multi')"
        :selected="true"
      ></select-box>
    </template>
    <span class="filename">{{ file.fileName }}</span>
    <span class="address-label" v-if="file.uploadFileType === 'ADDRESS_LIST'">
      - {{ file.quantity }} adressen</span
    >
    <button class="remove-file" @click.stop="$emit('remove', file)">
      <svg class="trash" width="15px" height="15px" viewBox="0 0 15 15">
        <title>Verwijderen</title>
        <g id="prullenmand">
          <path
            fill="#4f4f4f"
            d="M3,4 L3,13.25 C3,13.6642136 3.3581722,14 3.8,14 L10.2,14 C10.6418278,14 11,13.6642136 11,13.25 L11,4 L3,4 Z M9,2 L13,2 L13,3 L12,3 L12,13.4285714 C12,14.2964475 11.2538079,15 10.3333333,15 L3.66666667,15 C2.74619208,15 2,14.2964475 2,13.4285714 L2,3 L1,3 L1,2 L5,2 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 L8,0 C8.55228475,-1.01453063e-16 9,0.44771525 9,1 L9,2 Z M5,6 L5,12 L6,12 L6,6 L5,6 Z M8,6 L8,12 L9,12 L9,6 L8,6 Z"
          ></path>
        </g>
      </svg>
    </button>
  </section>
</template>

<script>
export default {
  props: ['file', 'selected'],
  emits: ['remove'],
  components: {},
  computed: {}
}
</script>

<style lang="scss" scoped>
.file-container {
  display: flex;
  border-radius: 20px;
  background-color: var(--selected-color);
  box-shadow: var(--default-shadow);

  padding: 0 15px;
  align-items: center;
  height: 45px;
  cursor: pointer;
  transition: all 0.5s;
  gap: 5px;

  .selected-row {
    margin-top: 30px; /* add a margin to the top of the selected row to increase the gap */
    margin-bottom: 10px; /* add a margin to the bottom of the selected row to decrease the gap with the following row */
  }

  &:hover {
    box-shadow: var(--default-shadow);
  }

  &.selected {
    background-color: var(--selected-color);
    box-shadow: var(--default-shadow);
  }

  &.analyzing {
    opacity: 0.6;
    cursor: auto;
  }

  .select-box {
    margin-top: 0;
    margin-right: 0;
    flex: 18px 0 0;
  }
}

.address-label {
  font-weight: 500;
  white-space: nowrap;
}

.error-text {
  font-size: 12px;
}

.product {
  font-weight: 500;
  padding-top: 0px;
}

.filename {
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex-grow: 1;
}

.remove-file {
  justify-self: end;
}

.trash {
  &:hover {
    path {
      transition: fill 0.4s;
      fill: #fd514d;
    }
  }
}

.prod-title {
  color: var(--action-color);
  font-weight: 600;
}
</style>
